import React, { useCallback } from 'react';
import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import RadioButton from '@/common/components/RadioButton';
import './NikeTvArchiveSearchFilterDialog.less';
import { FilterItem } from 'nike-ui/src/components/filters/types';
import { FilterAutoComplete } from 'nike-ui/src/components/filters/components/FilterAutocomplete';

export function NikeTvArchiveSearchFilterDialog({
    title,
    value,
    options,
    onSubmit,
    onClose
}: {
    title: React.ReactNode;
    value: FilterItem;
    options: FilterItem[];
    onSubmit: (selected: FilterItem) => void;
    onClose: () => void;
}) {
    const handleChange = useCallback(
        (event, value) => {
            onSubmit(value);
        },
        [onSubmit]
    );

    const [inputValue, setInputValue] = React.useState('');

    const handleInputChange = (event, value, reason) => {
        if (reason === 'reset') {
            if (event?.type === 'keydown' && (event as React.KeyboardEvent)?.key === 'Enter') {
                onClose();
            }
            return;
        }
        setInputValue(value);
    };

    return (
        <Docked className="nike-tv-search-filter">
            <DialogTitle>
                <h2>{title}</h2>
            </DialogTitle>
            <DialogBody className={'nike-tv-archive-search-filter-body'}>
                <FilterAutoComplete
                    value={value}
                    options={options}
                    inputValue={inputValue}
                    onInputChange={handleInputChange}
                    onChange={handleChange}
                    renderOption={(option, { selected }) => (
                        <RadioButton
                            key={option.value}
                            active={selected}
                            onClick={undefined}
                            className={'nui-ntv-filter-popper-item'}
                            data-atid={'niketv-filter-option'}
                        >
                            {option.value}
                        </RadioButton>
                    )}
                />
            </DialogBody>
        </Docked>
    );
}

export default NikeTvArchiveSearchFilterDialog;
